import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
`;

export const Toast = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 500px;
  word-wrap: break-word;
  animation: ${props => props.isVisible ? slideIn : slideOut} 0.3s ease-in-out;
  
  background-color: ${props => {
    const c = props.theme.colors;
    switch (props.type) {
      case 'success':
        return c.successBg;
      case 'error':
        return c.dangerBg;
      case 'warning':
        return c.warningBg;
      case 'info':
        return c.infoBg;
      default:
        return c.successBg;
    }
  }};

  color: ${props => {
    const c = props.theme.colors;
    switch (props.type) {
      case 'success':
        return c.successText;
      case 'error':
        return c.dangerText;
      case 'warning':
        return c.warningText;
      case 'info':
        return c.infoText;
      default:
        return c.successText;
    }
  }};

  border: 1px solid ${props => {
    const c = props.theme.colors;
    switch (props.type) {
      case 'success':
        return c.successBorder;
      case 'error':
        return c.dangerBorder;
      case 'warning':
        return c.warningBorder;
      case 'info':
        return c.infoBorder;
      default:
        return c.successBorder;
    }
  }};

  span {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
  }
`;